import { useIntl } from 'react-intl';
import { TooltipButton, useQueryFetch } from 'sonata-react-components';

import type { MultiFlightEntityState } from 'sonata-static-storage/lib/common/common.types';

const availableAdsStates: MultiFlightEntityState[] = ['launching', 'active', 'schedulePending', 'paused', 'finished'];

type Props = {
  className?: string;
  entityId: string;
  fetchState: () => Promise<{ state: MultiFlightEntityState }>;
  id: string;
  onClick: () => void;
  queryKey: string[];
};

export default function AdsValidationAction({
  className,
  entityId,
  fetchState,
  id,
  onClick,
  queryKey
}: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const { data, isLoading } = useQueryFetch([`${entityId}-adsState`, ...queryKey], fetchState);

  const isActive = data && availableAdsStates.includes(data.state);

  return (
    <TooltipButton
      buttonConfig={{
        buttonDisabled: !isActive,
        buttonLoading: isLoading,
        buttonOnClick: onClick,
        buttonShape: 'link',
        buttonSize: 'ultraSmall',
        buttonType: 'secondary'
      }}
      className={className}
      icon="fa-kit fa-regular-image-circle-check"
      id={id}
      isButton
      tooltipConfig={{
        tooltipEvent: 'mouseenter',
        tooltipPlace: 'top'
      }}
    >
      {formatMessage({
        defaultMessage: 'Check the status of your ad creatives',
        id: 'adsValidation.tooltip'
      })}
    </TooltipButton>
  );
}
